module.exports = __webpack_public_path__ + "img/img1.1812fcd3.png";